import * as React from 'react'
import * as BaseControls from './../common/BaseControls';
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
import HttpRequest from '../../service/httpService';
import { IDynamicList } from 'library/types/IDynamicList'

interface ISystemRadio extends IDynamicList {}

export default class SystemRadio extends SystemBase<ISystemRadio>
{
    constructor(props: any) {
        super(props)

    }

    private idField = this.props.idField || "id";
    private displayField = this.props.displayField || "text";

    componentDidMount = () => {

        if (this.props.dataSource && this.props.dataSourceType) {
            switch (this.props.dataSourceType) {

                case 'URL':
                    HttpRequest
                        .get(this.props.dataSource)
                        .then(response => {
                            let items: any = [];
                            if (response.data && response.data.length > 0) {
                                response.data.forEach((item: any) => {
                                    items.push({ id: item[this.idField], text: item[this.displayField]} )
                                })
                                this.setState({ listItems: items });
                            }
                        })
                        .catch(error => {
                        });
                    break;

                case 'CSV':
                    let items: any = [];
                    let temp = this.props.dataSource.split(",");
                    for (let i = 0; i < temp.length; i += 2) {
                        items.push({ id: temp[i], text: temp[i + 1] || '' } );
                    }
                    this.setState({ listItems: items });
                    break;

            }
        }
    }

    render() {
        return (
            <this.WrapperDiv>
            {
                this.state.listItems && this.state.listItems.length > 0 ?
                this.state.listItems.map((item: any, index: number) => {
                    return (
                        <div key={index} className="form-check-inline">
                            <label key={index} className="form-check-label">
                                <input type="radio" key={index}
                                    onChange={this.handleChange}
                                    onFocus={this.handleFocus}
                                    id={this.props.id}
                                    name={this.props.name}
                                    checked={this.state.value == item[this.idField]}
                                    value={item[this.idField]} />{item[this.displayField]}
                                   
                              </label>
                            </div>
                            )
                    
                })
                : this.props.children
            }
            </this.WrapperDiv> 
        );
    }
}
